/* eslint-disable tss-unused-classes/unused-classes */
import { makeStyles } from 'tss-react/mui'

export const useChartLegendStyles = makeStyles()(theme => ({
  container: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(1),
    flexDirection: 'row',
  },
  squareIndicatorWrapper: {
    height: '18px',
    width: '18px',
    marginRight: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.palette.grey.grey11,
  },
  squareIndicator: {
    height: '100%',
    width: '6px',
  },
  gridIndicator: {
    backgroundColor: theme.palette.chart.totalGridChargedBar,
  },
  solarIndicator: {
    backgroundColor: theme.palette.chart.solarChargedBar,
  },
  dischargeIndicator: {
    backgroundColor: theme.palette.chart.totalDischargedEnergyBackground,
  },
  costIndicator: {
    backgroundColor: theme.palette.chart.totalGridChargedBar,
  },
  indicatorLabel: {
    fontSize: '12px',
    fontWeight: 400,
    letterSpacing: '0.5px',
  },
}))
